import { useRef } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { hotTopics } from '@/mocks/hotTopics';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { comments } from '@/mocks/comments';

const schemaOrgData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '吃瓜爆料',
      url: 'http://94exue.cn/',
      description: '吃瓜爆料为您提供一站式吃瓜体验，实时更新全网热门吃瓜事件、明星八卦与网红黑料。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://94exue.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '吃瓜爆料',
      url: 'http://94exue.cn/',
      logo: 'http://94exue.cn/logo.png',
      description: '全网热门吃瓜事件实时更新平台',
      sameAs: [
        'http://94exue.cn/chiguabaoliao',
      ],
    },
    {
      '@type': 'WebPage',
      '@id': 'http://94exue.cn/#webpage',
      url: 'http://94exue.cn/',
      name: '吃瓜爆料 - 全网热门吃瓜事件实时更新',
      description: '吃瓜爆料为您提供一站式吃瓜体验，实时更新全网热门吃瓜事件、明星八卦与网红黑料，每日大赛劲爆内容不打烊。',
      isPartOf: { '@id': 'http://94exue.cn/#website' },
      about: { '@id': 'http://94exue.cn/#organization' },
    },
  ],
};

export default function Home() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -320, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 320, behavior: 'smooth' });
    }
  };

  const featuredArticles = articles.filter((a) => a.featured).slice(0, 6);
  const latestArticles = articles.slice(0, 6);

  const formatHotValue = (val: number) => {
    if (val >= 10000) return `${(val / 10000).toFixed(1)}万`;
    return val.toLocaleString();
  };

  return (
    <>
      <SEOHead
        title="吃瓜爆料 - 全网热门吃瓜事件实时更新"
        description="吃瓜爆料为您提供一站式吃瓜体验，实时更新全网热门吃瓜事件、明星八卦与网红黑料，每日大赛劲爆内容不打烊，免费在线观看最新瓜料，做最懂吃瓜的社区。"
        canonical="http://94exue.cn/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrgData) }}
      />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-screen min-h-[600px] flex flex-col justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20night%20scene%20of%20crowded%20urban%20street%20with%20neon%20signs%20and%20mysterious%20atmospheric%20lighting%2C%20deep%20emerald%20green%20and%20warm%20amber%20color%20palette%2C%20paparazzi%20style%20energy%2C%20abstract%20artistic%20interpretation%20of%20gossip%20and%20secrets%20unfolding%2C%20editorial%20photography%20with%20strong%20contrast%20and%20moody%20atmosphere&width=1920&height=1080&seq=hero-bg&orientation=landscape"
              alt="吃瓜爆料主视觉"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-12 lg:px-20 pt-24">
            <div className="max-w-3xl">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-8">
                <span className="block mb-2">全网热门吃瓜</span>
                <span className="block mb-2">事件实时更新</span>
                <span className="block">免费在线观看</span>
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-lg leading-relaxed">
                明星八卦、网红黑料、社会热点，每日大赛劲爆内容不打烊。一站式吃瓜体验，做最懂吃瓜的社区。
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/category/celebrity"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500/80 hover:bg-accent-500 text-white rounded-full text-sm font-medium transition-all backdrop-blur-sm whitespace-nowrap"
                >
                  开始吃瓜
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/category/daily"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-white/40 hover:border-white/70 text-white rounded-full text-sm font-medium transition-all backdrop-blur-sm whitespace-nowrap"
                >
                  每日大赛
                  <i className="ri-trophy-line" />
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-8 left-0 right-0 text-center z-10">
            <p className="text-6xl md:text-8xl lg:text-9xl font-heading font-black text-white/20 tracking-tight">
              吃瓜爆料
            </p>
          </div>
        </section>

        {/* Hot Topics Section */}
        <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  热门吃瓜 <span className="text-primary-500">实时榜单</span>
                </h2>
                <p className="text-sm text-foreground-500">全网最火爆的瓜料，热度实时更新</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={scrollLeft}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-white hover:bg-foreground-700 transition-colors"
                  aria-label="向左滚动"
                >
                  <i className="ri-arrow-left-line" />
                </button>
                <button
                  onClick={scrollRight}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-white hover:bg-foreground-700 transition-colors"
                  aria-label="向右滚动"
                >
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>

            <div
              ref={scrollRef}
              className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {hotTopics.map((topic) => (
                <Link
                  key={topic.id}
                  to={`/article/${topic.id.replace('hot', 'article')}`}
                  className="flex-shrink-0 w-64 md:w-72 group"
                >
                  <div className="relative rounded-xl overflow-hidden mb-3 aspect-square">
                    <img
                      src={topic.image}
                      alt={topic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center px-2.5 py-1 bg-primary-500 text-white text-xs font-bold rounded-full">
                        {topic.tag}
                      </span>
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5 leading-snug">
                    {topic.title}
                  </h3>
                  <p className="text-xs text-primary-600 font-semibold">
                    {formatHotValue(topic.hotValue)} 热度
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles Grid */}
        <section className="bg-background-50 py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-10 gap-4">
              <div>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-2">
                  精选爆料
                </h2>
                <p className="text-sm text-foreground-500">编辑精选最劲爆的瓜料，绝不让你错过任何精彩</p>
              </div>
              <Link
                to="/category/celebrity"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看更多
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className={`group block rounded-xl overflow-hidden transition-all hover:-translate-y-1 ${
                    index === 0
                      ? 'md:col-span-2 lg:col-span-1 bg-foreground-800'
                      : 'bg-background-100 border border-background-200/70'
                  }`}
                >
                  <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[4/3]' : 'aspect-[16/10]'}`}>
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span
                        className={`inline-flex items-center px-2.5 py-1 text-xs font-bold rounded-full ${
                          index === 0
                            ? 'bg-white/20 text-white backdrop-blur-sm'
                            : 'bg-secondary-100 text-secondary-800'
                        }`}
                      >
                        {article.categoryName}
                      </span>
                    </div>
                  </div>
                  <div className={`p-4 md:p-5 ${index === 0 ? 'bg-foreground-800' : ''}`}>
                    <h3
                      className={`text-base font-semibold mb-2 line-clamp-2 leading-snug ${
                        index === 0 ? 'text-white' : 'text-foreground-900 group-hover:text-primary-600'
                      } transition-colors`}
                    >
                      {article.title}
                    </h3>
                    <p
                      className={`text-xs line-clamp-2 mb-3 ${
                        index === 0 ? 'text-white/70' : 'text-foreground-500'
                      }`}
                    >
                      {article.summary}
                    </p>
                    <div
                      className={`flex items-center justify-between text-xs ${
                        index === 0 ? 'text-white/60' : 'text-foreground-400'
                      }`}
                    >
                      <span>{article.publishDate}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-500" />
                        {formatHotValue(article.hotValue)}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="bg-secondary-50 py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                <i className="ri-compass-3-line" />
                分类浏览
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                四大吃瓜频道
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:-translate-y-1 transition-all"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                    <i className={`${cat.icon} text-xl`} />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                    {cat.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{cat.articleCount} 篇爆料</span>
                    <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-line text-xs" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Daily Competition Section */}
        <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
                <i className="ri-trophy-line" />
                每日大赛
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-700 mb-2">
                瓜友口碑榜
              </h2>
              <p className="text-sm text-foreground-500">每天投票选出最震撼的瓜，由广大瓜友说了算</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles
                .filter((a) => a.category === 'daily')
                .slice(0, 3)
                .map((article, index) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className={`group block rounded-xl overflow-hidden transition-all hover:-translate-y-1 ${
                      index === 0 ? 'bg-accent-500' : 'bg-background-50 border border-background-200/70'
                    }`}
                  >
                    <div className="p-5 md:p-6">
                      <div className="flex items-center gap-3 mb-4">
                        <img
                          src={article.authorAvatar}
                          alt={article.author}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                        <div>
                          <p className={`text-xs font-medium ${index === 0 ? 'text-white' : 'text-foreground-700'}`}>
                            {article.author}
                          </p>
                          <p className={`text-xs ${index === 0 ? 'text-white/70' : 'text-foreground-400'}`}>
                            {article.publishDate}
                          </p>
                        </div>
                      </div>
                      <h3
                        className={`text-base font-semibold mb-3 line-clamp-2 leading-snug ${
                          index === 0 ? 'text-white' : 'text-foreground-900 group-hover:text-primary-600'
                        } transition-colors`}
                      >
                        {article.title}
                      </h3>
                      <p className={`text-xs line-clamp-3 leading-relaxed ${index === 0 ? 'text-white/80' : 'text-foreground-500'}`}>
                        {article.summary}
                      </p>
                      <div className="mt-4 flex items-center justify-between">
                        <span className={`text-xs ${index === 0 ? 'text-white/60' : 'text-foreground-400'}`}>
                          {formatHotValue(article.hotValue)} 热度
                        </span>
                        <span
                          className={`inline-flex items-center gap-1 text-xs font-medium ${
                            index === 0 ? 'text-white' : 'text-primary-600'
                          }`}
                        >
                          查看详情
                          <i className="ri-arrow-right-line" />
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="bg-background-50 py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-8 md:mb-10">
              <div>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-2">
                  最新爆料
                </h2>
                <p className="text-sm text-foreground-500">第一时间获取全网最新瓜料</p>
              </div>
              <Link
                to="/category/social"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看更多
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="space-y-4">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex flex-col sm:flex-row gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all"
                >
                  <div className="w-full sm:w-48 md:w-56 flex-shrink-0 rounded-lg overflow-hidden aspect-[16/10] sm:aspect-[4/3]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                        {article.categoryName}
                      </span>
                      <span className="text-xs text-foreground-400">{article.publishDate}</span>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed hidden sm:block">
                      {article.summary}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line" />
                        {article.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-500" />
                        {formatHotValue(article.hotValue)}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line" />
                        {article.readTime}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Comments Section */}
        <section className="bg-secondary-50 py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                <i className="ri-chat-3-line" />
                瓜友热议
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                大家都在说什么
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {comments.slice(0, 6).map((comment, index) => (
                <div
                  key={comment.id}
                  className={`p-5 md:p-6 rounded-xl ${
                    index % 3 === 0
                      ? 'bg-background-50 border border-background-200/70'
                      : index % 3 === 1
                        ? 'bg-accent-500 text-white'
                        : 'bg-primary-500 text-white'
                  }`}
                >
                  <div className="mb-4">
                    <i
                      className={`ri-double-quotes-l text-2xl ${
                        index % 3 === 0 ? 'text-primary-300' : 'text-white/40'
                      }`}
                    />
                  </div>
                  <p
                    className={`text-sm leading-relaxed mb-5 ${
                      index % 3 === 0 ? 'text-foreground-600' : 'text-white/90'
                    }`}
                  >
                    {comment.content}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2.5">
                      <img
                        src={comment.avatar}
                        alt={comment.author}
                        className="w-8 h-8 rounded-full object-cover"
                      />
                      <div>
                        <p
                          className={`text-xs font-medium ${
                            index % 3 === 0 ? 'text-foreground-700' : 'text-white'
                          }`}
                        >
                          {comment.author}
                        </p>
                        <p
                          className={`text-xs ${
                            index % 3 === 0 ? 'text-foreground-400' : 'text-white/60'
                          }`}
                        >
                          {comment.date}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      <i
                        className={`ri-heart-fill text-xs ${
                          index % 3 === 0 ? 'text-primary-500' : 'text-white/60'
                        }`}
                      />
                      <span
                        className={`text-xs ${
                          index % 3 === 0 ? 'text-foreground-500' : 'text-white/60'
                        }`}
                      >
                        {comment.likes}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20wide%20panoramic%20scene%20of%20giant%20watermelon%20field%20under%20dramatic%20sunset%20sky%20with%20golden%20hour%20lighting%2C%20warm%20amber%20and%20deep%20green%20color%20palette%2C%20surreal%20dreamlike%20atmosphere%2C%20editorial%20landscape%20photography%20with%20strong%20visual%20impact%20and%20moody%20cinematic%20tone&width=1920&height=800&seq=cta-bg&orientation=landscape"
              alt="加入吃瓜社区"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/50" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-12 lg:px-20 py-16">
            <div className="max-w-3xl">
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
                加入吃瓜社区
              </h2>
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
                一起做最懂吃瓜的人
              </h2>
              <p className="text-sm md:text-base text-white/80 mb-8 max-w-lg leading-relaxed">
                订阅吃瓜爆料，第一时间获取全网最新瓜料推送。每日大赛、独家爆料、瓜友互动，精彩不容错过。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-3 px-6 py-3 bg-white text-foreground-900 rounded-full text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap"
              >
                立即加入
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 text-white">
                  <i className="ri-arrow-right-line text-xs" />
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
